import { Component, Input } from '@angular/core';
import { IFinancialTableData, RowTypes } from '@modeso/aumico-lib-annualreport-fe';
import { IPrintOptions } from '@modeso/types__aumico-lib-annualreport-be';

@Component({
    selector: 'aumico-notes-component-display',
    templateUrl: './notes-component-display.component.html',
    styleUrls: ['./notes-component-display.component.scss'],
})
export class NotesComponentDisplayComponent {
    @Input() set sectionNotes(value: IFinancialTableData[]) {
        let data: IFinancialTableData[][] = [[]];
        let currentIndex = 0;

        for (const item of value) {
            if (item.rowType === RowTypes.TABLE_HEAD) {
                currentIndex++;
                data[currentIndex] = [item];
            } else if (currentIndex >= 0) {
                data[currentIndex].push(item);
            }
        }
        data = data.filter((subArray) => subArray.length > 0);
        this.sectionData = data;
    }
    @Input() set printOptionStyles(value: IPrintOptions | undefined) {
        if (value != null) {
            this.textColor = value.styleOptions.textColor;
            this.tableHeaderColor = value.styleOptions.tableHeaderColor;
            this.tableFooterColor = value.styleOptions.tableFooterColor;
            this.backgroundColor = value.styleOptions.backgroundColor;
            this.backgroundColorPY = value.styleOptions.backgroundColorPY;
        }
    }
    @Input() noPreviousData: boolean;
    /**
     * FX (REV-21512): comes from the item, not from a cell — on an FX report every date header
     * carries the column currency on a second line, so the break has to survive rendering.
     */
    @Input() isFxFormat = false;

    textColor: string;
    tableHeaderColor: string;
    tableFooterColor: string;
    backgroundColor: string;
    backgroundColorPY: string;
    public sectionData: IFinancialTableData[][];

    /**
     * FX (REV-21512): a table renders the display-currency twin columns as soon as any of its
     * rows carries them (`cV2`/`pV2` — the mappers set them only on FX reports in the `both`
     * state). Non-FX rows never have the fields, so the legacy 3-column layout is untouched.
     */
    /** FX (REV-21512): memoized per section array — bound per cell in the template. */
    private readonly fxColumnsCache = new WeakMap<object, boolean>();

    hasFxColumns(sectionTable: Array<{ cV2?: string | null }> | undefined): boolean {
        if (sectionTable == null) {
            return false;
        }
        let has = this.fxColumnsCache.get(sectionTable);
        if (has === undefined) {
            has = sectionTable.some((row) => row.cV2 !== undefined);
            this.fxColumnsCache.set(sectionTable, has);
        }

        return has;
    }

    constructor() {}
}
